module.exports = __webpack_public_path__ + "static/diamond-desc-18e02b2cbcb68ddae8b6b76b73f82737.png";